import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import {message, Button, Table, Select, Input} from 'antd';
import {hasAuth, createUuid} from "../../../utils/NHCore";
import NHFetch from "../../../utils/NHFetch";

/**
 * 手机号码汇总
 * @author yangqizhi
 */
class Sjhmhz extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
            isShowXyw: false, // 是否显示【是否开通校园网】字段
            success: false, // 接口加载成功的回调状态
        }
    }

    // 自选手机号是否关联校园网
    // （关联时：显示是否开通校园网字段，无论是否自选手机号都会显示在内）
    // （不关联时：只显示自选了手机号码的学生，且不显示开通校园网字段）
    componentWillMount() {
        NHFetch('api/zhxg-xtgl/openapi/getCsszByCsbz', "GET", {csbz: 'YXXT_ZXSJH_SFXYGLXYW'})
            .then(res => {
                if (res) {
                    if (res.data && res.code === 200) {
                        if (res.data.csz === 'true') {
                            this.setState({isShowXyw: true});
                        }
                    }
                }
            }).then(() => this.setState({success: true}));
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('已选手机号码信息汇总');
    }

    render() {
        const columnConst = [
            {
                title: '序号',
                key: 'ROW_ID',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                key: 'XH',
                dataIndex: 'XH',
                width: '80px',
                searchType: "input"
            }, {
                title: '姓名',
                key: 'XM',
                dataIndex: 'XM',
                width: '80px',
                search: 'input',
                searchType: "input"
            }, {
                title: '身份证号',
                key: 'SFZJH',
                dataIndex: 'SFZJH',
                width: '140px',
                searchType: "input"
            }, {
                title: '运营商',
                key: 'YYSMC',
                width: '80px',
                dataIndex: 'YYSMC',
                searchType: "input"
            }, {
                title: '已选手机号码',
                key: 'SJH',
                width: '120px',
                dataIndex: 'SJH',
                searchType: "input"
            }];// (该列的内容是所有自选了手机号的学生的信息，不含是否开通校园网字段)

        const columnConst2 = [
            {
                title: '序号',
                key: 'ROW_ID',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                key: 'XH',
                dataIndex: 'XH',
                width: '80px',
                searchType: "input"
            }, {
                title: '姓名',
                key: 'XM',
                dataIndex: 'XM',
                width: '80px',
                search: 'input',
                searchType: "input"
            }, {
                title: '身份证号',
                key: 'SFZJH',
                dataIndex: 'SFZJH',
                width: '140px',
                searchType: "input"
            }, {
                title: '运营商',
                key: 'YYSMC',
                width: '80px',
                dataIndex: 'YYSMC',
                searchType: "input"
            }, {
                title: '已选手机号码',
                key: 'SJH',
                width: '120px',
                dataIndex: 'SJH',
                searchType: "input"
            }, {
                title: '是否开通校园网',
                key: 'SFKTXYW',
                width: '100px',
                dataIndex: 'SFKTXYW',
            }]// (该列的内容是无论是否自选手机号都包含在内，且增加是否开通校园网字段)

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div style={{width: '100%', height: '100%',}}>
                    {this.state.success ?
                        <NHTable
                            ref='nhTable'
                            rowKey={record => record.ROW_ID}
                            sign={this.state.isShowXyw ? "zhxg_yxxt_tjcx_sjhmhz_sfktxyw_queryPage" : "zhxg_yxxt_tjcx_sjhmhz_queryPage"}
                            columns={this.state.isShowXyw ? columnConst2 : columnConst}
                            rangeFilter={true}
                        >
                            {
                                hasAuth("zhxg_yxgl_tjcx_sjhmhz:export") ?
                                    <Button type="primary" ghost onClick={this.handleOtpBtnClick}
                                            style={{marginLeft: 10}}>导出</Button>
                                    : null
                            }
                        </NHTable>
                        : null
                    }
                </div>
            </div>
        )
    }
}

export default Sjhmhz;



// WEBPACK FOOTER //
// ./components/tjcx/sjhmhz/index.js